<template>
  <div id="app">
    <router-view/>
    
<!--    <transition name="toast">-->
<!--      <toast v-if="toast.show"></toast>-->
<!--    </transition>-->
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'
  import Stomp from "stompjs"
  // import 'swiper/dist/css/swiper.css'

  export default {
    name: 'App',
    components: {},
    data() {
      return {
        wsClient: null,
      }
    },
    computed: {
      ...mapState(['toast']),
    },
    created() {
      // console.log("app created", this.$route.params);
      this.getActivityId(this.$route.params.randomString).then(res => {
        this.connectWs()
      })
    },
    mounted() {
      window.onresize = () => {
        this.windowResize()
      }
    },
    methods: {
      ...mapActions(['getActivityId', 'setActivityId',
        'hideToast',
        'updateMode',
        'getShareData',
        'getAllBlessingList',
        'addBlessing',
        'updateLottery',
        'windowResize']),
      connectWs() {
        // console.log("connectWs", this.$store.state.activityId);
        var url = this.$store.state.host.ws + '?activityId=' + this.$store.state.activityId;
        this.wsClient = Stomp.client(url);
        // this.wsClient.connect({}, this.wsConnectCallback, this.wsErrorCallback)
        this.wsClient.connect('', '', this.wsConnectCallback, this.wsErrorCallback)
        // this.wsClient.connect('', '', this.wsConnectCallback, this.wsErrorCallback, this.wsCloseCallback)
      },
      wsConnectCallback() {
        this.wsClient.subscribe('/user/mode', res => {
          let resBody = JSON.parse(res.body)
          console.info('/user/mode')
          // console.info('/user/mode', resBody.data)
          this.updateMode(resBody.data)
        })
        // 祝福推送
        this.wsClient.subscribe('/user/blessing', res => {
          let resBody = JSON.parse(res.body)
          console.info('/user/blessing')
          // console.info('/user/blessing', resBody.data)
          this.addBlessing(resBody.data)
        });
        // 抽奖推送
        this.wsClient.subscribe('/user/lottery', res => {
          let resBody = JSON.parse(res.body)
          console.info('/user/lottery')
          // console.info('/user/lottery', resBody.data)
          this.updateLottery(resBody.data)
        });
      },
      wsErrorCallback(err) {
        console.log('Socket 连接失败', err)
      },
      wsCloseCallback(err) {
        console.log('Socket 断开连接', err)
      },
      disconnectWs() {
        if (this.wsClient !== null) {
          this.wsClient.disconnect();
        }
        console.log('断开连接');
      },
    },
    watch: {},
    
    beforeDestroy() {
      this.disconnectWs()
    },
    
  }
</script>

<style>
  @import "./less/common.less";
  @import "./less/app.less";
  
</style>



// WEBPACK FOOTER //
// src/App.vue